import modelRequest, { RequestError } from './lib/modelRequest'

export interface ProbeDetails {
  title: string
  link: string
}

export interface SelectedReadingProbe {
  program: "reading"
  phonics?: ProbeDetails
  phrases?: ProbeDetails
  alphabet?: ProbeDetails
  stories?: ProbeDetails
}
export interface SelectedMathProbe {
  program: "math"
  addition?: ProbeDetails
  subtraction?: ProbeDetails
  multiplication?: ProbeDetails
  division?: ProbeDetails
}

export type SelectedProbe = SelectedReadingProbe | SelectedMathProbe

export default {
  /**
   * Gets the probes selected by the teacher
   */
  get: (): Promise<SelectedProbe & RequestError> => {
    return modelRequest.get('/api/students/student-probes')
  },
}
